import axios from "axios";

export default {
  namespaced: true,
  state: {
    prices: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    pricesMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_PRICES(state, payload) {
      state.prices = payload;
      state.isReceiving = false;
    },
    RECEIVING_PRICES(state) {
      state.isReceiving = true;
    },
    RECEIVED_PRICE(state, payload) {
      console.log("RECEIVED PRICE", payload);
      state = Object.assign(state, {
        prices: [...state.prices, payload],
        isReceiving: false,
      })
    },
    RECEIVING_PRICE(state) {
      state.isReceiving = true;
    },
    UPDATED_PRICE(state, payload) {
      console.log(state.prices);
      console.log(payload);
      let index = state.prices.findIndex(price => price._id === payload._id);
      state = Object.assign(state, {
        prices: state.prices.map((price, i) => {
          if (i === index) {
            return Object.assign({}, price, payload);
          }
          return price;
        }),
        isUpdating: false,
        pricesMessage: 'Prices has been updating!',
      })
    },
    UPDATING_PRICE(state) {
      state.isUpdating = true;
    },
    DELETED_PRICE(state, payload) {
      console.log("DELETE", payload);
      let indexToDelete = state.prices.findIndex(price => price._id === payload._id);
      console.log(indexToDelete);
      let prices = [...state.prices];
      prices.splice(indexToDelete, 1);
      state = Object.assign(state, {
        prices: [...prices],
        isDeleting: false,
        idToDelete: null,
        pricesMessage: 'Price has been Deleted!',
      });
    },
    DELETING_PRICE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    getPricesRequest({dispatch}) {
      dispatch("receivingPrices");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/prices';
      var headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token };
      var get = { method: "get", url: url, headers: headers };
      axios(get).then(res => {
        dispatch("receivePrices", res.data);
      })
    },
    async updatePriceRequest({dispatch}, payload) {
      dispatch("updatingPrice");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/price/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "put", url: url, headers: headers, data: payload});
      dispatch("updatePrice", response.data);
      return response.data;
    },
    async updatePriceDiscountRequest({dispatch}, payload) {
      dispatch("doNothing");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/pricediscount/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "put", url: url, headers: headers, data: payload});
      return response.data;
    },
    async updateFocRequest({dispatch}, payload) {
      dispatch("updatingPrice");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/price/foc/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "put", url: url, headers: headers, data: payload});
      dispatch("updatePrice", response.data);
      return response.data;
    },
    async insertPriceRequest({dispatch}, payload) {
      dispatch("receivingPrices");
      let token = localStorage.getItem('token');
      var id = payload.pricelistid;
      delete payload['pricelistid'];
      let url = 'https://api.tradexc.com:3000/insert/price/' + id;
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method: "post", url: url,headers: headers, data: data})
      dispatch("receivePrice", response.data);
      return response.data;
    },
    async insertPriceDiscountRequest({dispatch}, payload) {
      dispatch("doNothing");
      let token = localStorage.getItem('token');
      var id = payload.pricelistid;
      delete payload['pricelistid'];
      let url = 'https://api.tradexc.com:3000/insert/pricediscount/' + id;
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method: "post", url: url,headers: headers, data: data})
      return response.data;
    },
    async deletePriceRequest({dispatch}, payload) {
      dispatch("deletingPrice", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/price/' + payload._id;
      var header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      let response =  await axios({method: "delete",url: url,headers: header})
      dispatch("deletePrice", response.data);
      return response.data;
    },
    async deletePriceDiscountRequest({dispatch}, payload) {
      dispatch("doNothing");
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/pricediscount/' + payload._id;
      var header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      let response =  await axios({method: "delete",url: url,headers: header})
      return response.data;
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receivePrices({commit}, payload) {
      commit("RECEIVED_PRICES", payload)
    },
    receivingPrices({commit}) {
      commit("RECEIVING_PRICES")
    },
    receivePrice({commit}, payload) {
      commit("RECEIVED_PRICE", payload)
    },
    receivingPrice({commit}) {
      commit("RECEIVING_PRICE")
    },
    updatePrice({commit}, payload) {
      commit("UPDATED_PRICE", payload)
    },
    updatingPrice({commit}) {
      commit("UPDATING_PRICE")
    },
    deletePrice({commit}, payload) {
      console.log(payload);
      commit("DELETED_PRICE", payload)
    },
    deletingPrice({commit}, payload) {
      commit("DELETING_PRICE", payload)
    }
  },
};
